import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private isDarkModeSubject = new BehaviorSubject<boolean>(true);
  isDarkMode$ = this.isDarkModeSubject.asObservable();

  darkTheme: NgxMaterialTimepickerTheme = {
    container: { bodyBackgroundColor: '#424242', buttonColor: '#fff' },
    dial: { dialBackgroundColor: '#555' },
    clockFace: {
      clockFaceBackgroundColor: '#555',
      clockHandColor: '#009688',
      clockFaceTimeInactiveColor: '#fff',
    },
  };

  lightTheme: NgxMaterialTimepickerTheme = {
    container: { bodyBackgroundColor: '#ffffff', buttonColor: '#000', },
    dial: { dialBackgroundColor: '#424242' },
    clockFace: {
      clockFaceBackgroundColor: '#ffffff',
      clockHandColor: '#009688',
      clockFaceTimeInactiveColor: '#000',
    },

  };

  constructor(private userService: UserService) {
    this.userService.userProfile$
      .subscribe(user => {
        this.applyTheme(user?.preferredTheme || 'darkMode');
      })
  }

  applyTheme(theme: 'lightMode' | 'darkMode' | null): void {
    switch (theme) {
      case 'lightMode':
        document.body.classList.add('lightMode');
        document.body.classList.remove('darkMode');
        this.isDarkModeSubject.next(false);
        break;
      case 'darkMode':
      default:
        document.body.classList.add('darkMode');
        document.body.classList.remove('lightMode');
        this.isDarkModeSubject.next(true);
        break;
    }
  }

  getTimepickerTheme(isDarkMode: boolean): NgxMaterialTimepickerTheme {
    return isDarkMode ? this.darkTheme : this.lightTheme;
  }


}


